const text = value => String(value ?? "").trim();

// Keep the draft limited to editable fields; identity and authority come from the server.
export function profileDraft(tenant) {
    return {
        tenantNameEn: tenant?.tenantNameEn ?? "", tenantEmail: tenant?.tenantEmail ?? "",
        website: tenant?.website ?? "", registrationNumber: tenant?.registrationNumber ?? "",
        about: tenant?.about ?? "", foundedYear: String(tenant?.foundedYear || ""),
        address: {...tenant?.address}, phones: (tenant?.phones || []).map(phone => ({...phone})),
    };
}

export function profilePayload(latest, draft) {
    return {
        ...latest, ...profileDraft(draft),
        tenantNameEn: text(draft.tenantNameEn), tenantEmail: text(draft.tenantEmail),
        website: text(draft.website), registrationNumber: text(draft.registrationNumber),
        foundedYear: Number(draft.foundedYear) || 0,
        address: {...latest.address, ...Object.fromEntries(
            ["street", "city", "country"].map(field => [field, text(draft.address?.[field])]))},
        phones: draft.phones.map(phone => ({
            phoneNumberCode: text(phone.phoneNumberCode), phoneNumber: text(phone.phoneNumber),
        })),
    };
}

export function validateProfile(draft) {
    const errors = {};
    if (!text(draft.tenantNameEn)) errors.tenantNameEn = "ProfileRequired";
    if (!/^[a-zA-Z0-9_+&*-]+(?:[.'][a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,15}$/.test(text(draft.tenantEmail))) {
        errors.tenantEmail = "ProfileInvalidEmail";
    }
    ["street", "city", "country"].forEach(field => {
        if (!text(draft.address?.[field])) errors[field] = "ProfileRequired";
    });
    if (draft.foundedYear !== "" && (!Number.isInteger(Number(draft.foundedYear)) ||
        Number(draft.foundedYear) < 1 || Number(draft.foundedYear) > new Date().getFullYear())) {
        errors.foundedYear = "ProfileInvalidYear";
    }
    if (text(draft.website)) {
        try {
            const url = new URL(/^[a-z]+:/i.test(text(draft.website)) ? text(draft.website) : `https://${text(draft.website)}`);
            if (!["http:", "https:"].includes(url.protocol) || !url.hostname || url.username || url.password) throw new Error();
        } catch { errors.website = "ProfileInvalidWebsite"; }
    }
    draft.phones.forEach((phone, index) => {
        if (!/^\+\d{1,4}$/.test(text(phone.phoneNumberCode))) errors[`phoneCode${index}`] = "ProfileInvalidPhoneCode";
        if (!/^(?=(?:\D*\d){3})[\d\s()\-]{3,25}$/.test(text(phone.phoneNumber))) errors[`phone${index}`] = "ProfileInvalidPhone";
    });
    return errors;
}
